import { ModelService } from './model-service.js';
/**
 * Helper class for running multiple validatons for the same value
*/
class ValidationRunner {
    constructor(value) {
        this.validators = [];
        this.value = value;
    }
    /**
     * Adds a new validator to the list
     *
     * @param validatorName the validator name
     * @param options the validator configuration
    */
    apply(validatorName, options) {
        if (validatorName) {
            const validator = ModelService.getValidator(validatorName);
            this.validators.push({ options, validator });
        }
        return this;
    }
    /**
     * Executes all validators with the value stored
    */
    run() {
        return this.validators.reduce((all, { validator, options }) => {
            return all.concat(validator(this.value, options));
        }, []);
    }
}
export { ValidationRunner, };
//# sourceMappingURL=validation-runner.js.map